var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaIcRotateArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 15.1671C4.5333 15.1671 1.71997 12.3471 1.71997 8.88708C1.71997 7.64042 2.08664 6.43375 2.77997 5.39375C2.9333 5.16708 3.24664 5.10042 3.4733 5.25375C3.69997 5.40708 3.76664 5.72042 3.6133 5.94708C3.0333 6.81375 2.72664 7.83375 2.72664 8.88042C2.72664 11.7937 5.0933 14.1604 8.00664 14.1604C10.92 14.1604 13.2866 11.7937 13.2866 8.88042C13.2866 5.96708 10.9133 3.60042 7.99997 3.60042C7.38664 3.60042 6.78664 3.68708 6.21997 3.86042C5.9533 3.94042 5.6733 3.79375 5.5933 3.52708C5.5133 3.26042 5.65997 2.98042 5.92664 2.90042C6.5933 2.70042 7.28664 2.59375 7.99997 2.59375C11.4666 2.59375 14.28 5.41375 14.28 8.87375C14.28 12.3338 11.4666 15.1671 7.99997 15.1671Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24674 4.0461C5.13341 4.0461 5.01341 4.0061 4.92008 3.9261C4.70674 3.73943 4.68674 3.4261 4.86674 3.21943L6.79341 1.0061C6.97341 0.799429 7.29341 0.772763 7.50008 0.959429C7.70674 1.13943 7.72674 1.45943 7.54674 1.6661L5.62008 3.87276C5.52008 3.9861 5.38008 4.0461 5.24674 4.0461Z",
    fill: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49338 5.6861C7.39338 5.6861 7.28672 5.65277 7.20005 5.59277L4.94672 3.9461C4.72672 3.7861 4.68005 3.47277 4.84005 3.25277C5.00005 3.0261 5.31338 2.97943 5.54005 3.13943L7.78672 4.77943C8.00672 4.93943 8.06005 5.25277 7.89338 5.47943C7.80005 5.61943 7.64672 5.6861 7.49338 5.6861Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaIcRotateArrow);
export default __webpack_public_path__ + "static/media/pa_ic_rotate_arrow.ba13f2b64c881b60b96161ffd65d9d52.svg";
export { ForwardRef as ReactComponent };